import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Immutable from 'immutable';
import moment from 'moment';

import { Menu } from '@uncinc/react-drupal-core';
import { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import useClasses from '../../../../hooks/useClasses';
import useRoutes from '../../../../hooks/useRoutes';
import MenuMainItem from '../Item';
import MenuMainItemStatistic from '../Item/Statistic';
import { ImmutableMenuItem, MilestoneTaxonomyProps } from '../..';
import { DOMAIN_ZELFHULP_NAASTEN } from '../../../../config/constants';

import './style.scss';

const MenuTool: React.FC<React.HTMLProps<HTMLAttributes<HTMLMenuElement>>> = ({ className }) => {
  const { t } = useTranslation();
  const { badges, calendar } = useRoutes();
  const { buildClass, joinClasses } = useClasses('MenuTool');

  const uid = useSelector((state: ImmutableRootState<number>) => state.getIn(['login', 'uid'], null));
  const currentDomain = useSelector((state: ImmutableRootState<string>) => state.getIn(['uiInternal', 'currentDomain', 'raw'], null));
  const streakCount = useSelector((state: ImmutableRootState<number>) => state.getIn(['registrations', 'streaks', 'completed'], 0));
  const badgeArray = useSelector((state: ImmutableRootState<MilestoneTaxonomyProps['field_badges']>) => (
    state.getIn(['user', uid, 'field_badges'], Immutable.List())
  ));
  const dateStarted = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['registrations', 'registrationsStartDate']));
  const daysSinceStart = moment().diff(moment(dateStarted).startOf('day'), 'day') + 1;

  const badgeCount = badgeArray.size;

  return (
    <nav className={joinClasses(buildClass(), className)}>
      <Menu id="main">
        {(entities: ImmutableMenuItem[]) => (
          <ul className={buildClass('list')}>
            {currentDomain !== DOMAIN_ZELFHULP_NAASTEN && (
              <MenuMainItemStatistic
                className="icon-medallion"
                href={badges}
                title={t('pages.badges.link_title', { count: badgeCount })}
                titleMobile={String(badgeCount)}
              />
            )}
            {currentDomain !== DOMAIN_ZELFHULP_NAASTEN && (
              <MenuMainItemStatistic
                className="icon-calendar icon-variant-10"
                href={calendar}
                title={t('common:blocks.streak.default.registration_days', { count: streakCount, total: daysSinceStart })}
                titleMobile={`${streakCount || 0}`}
              />
            )}
            {entities.map((entity) => (
              <MenuMainItem entity={entity} />
            ))}
          </ul>
        )}
      </Menu>
    </nav>
  );
};

export default MenuTool;
